<form
    ng-form="fieldRecordDetailsForm"
    class="well">
    <h5>Field record details</h5>

    <div class="row">
        <div class="col-xs-3">
            <label class="control-label required-input">Field record number</label>
            <div
                class="input-group"
                [ngClass]="{'has-error': !fieldRecordNumber.value  && (fieldRecordNumber.dirty || submitted)}">
                <span class="input-group-addon">
                    <i class="nlrp-icon nlrp-icon-edit"></i>
                </span>
                <input
                    #fieldRecordNumber="ngModel"
                    type="number"
                    name="fieldRecordNumber"
                    id="fieldRecordNumber"
                    class="form-control"
                    [(ngModel)]="model.fieldRecordNumber"
                    (ngModelChange)="onInputChange($event)"
                    required
                    maxlength-input-limit="8" />
            </div>
        </div>
        <div class="col-xs-3">
            <label class="control-label required-input">Category</label>
            <div class="input-group">
                <ng-select
                    class="nlr-ng-select"
                    #category="ngModel"
                    [searchable]="false"
                    [clearable]="false"
                    [ngClass]="{'has-error': !isCategoryValid() && submitted}"
                    name="category"
                    id="category"
                    placeholder="Select"
                    [items]="categories"
                    [ngModel]="model.category"
                    (ngModelChange)="updateSelectedCategory($event)"
                    required>
                </ng-select>
            </div>
        </div>
        <div class="col-xs-6">
            <label class="control-label required-input">Purpose</label>
            <div class="input-group">
                <ng-select
                    class="nlr-ng-select"
                    #purpose="ngModel"
                    [searchable]="false"
                    [clearable]="false"
                    [ngClass]="{'has-error': !isPurposeValid() && submitted}"
                    name="purpose"
                    id="purpose"
                    placeholder="Select"
                    [items]="filterPurposes()"
                    [trackByFn]="purposeTrackBy"
                    bindLabel="purpose"
                    [ngModel]="selectedPurpose"
                    (ngModelChange)="updateSelectedPurpose($event)"
                    [disabled]="!model.category"
                    required>
                </ng-select>
            </div>
        </div>
    </div>
</form>
